<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header'>All Vehicles</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/vehicles/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/vehicles/vor'><i class="fas fa-minus-circle"></i> Manage VORs</button>
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='vehicle'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
